import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "relative flex flex-col" }
const _hoisted_2 = { class: "mb-2 text-lg font-semibold" }
const _hoisted_3 = { class: "min-w-full border-separate border-spacing-0" }
const _hoisted_4 = { class: "whitespace-nowrap border-b border-gray-200 px-3 py-1.5 text-sm font-medium" }
const _hoisted_5 = { class: "whitespace-nowrap border-b border-gray-200 px-3 py-1.5 text-sm font-medium" }
const _hoisted_6 = { class: "whitespace-nowrap border-b border-gray-200 px-3 py-1.5 text-center text-sm font-medium" }
const _hoisted_7 = { class: "whitespace-nowrap border-b border-gray-200 px-3 py-1.5 text-sm font-medium" }
const _hoisted_8 = { class: "whitespace-nowrap border-b border-gray-200 px-3 py-1.5 text-center text-sm font-medium" }
const _hoisted_9 = { class: "whitespace-nowrap border-b border-gray-200 px-3 py-1.5 text-center text-sm font-medium" }
const _hoisted_10 = { class: "whitespace-nowrap border-b border-gray-200 px-3 py-1.5 text-center text-sm font-medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiPanel = _resolveComponent("UiPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('report.realtime.userDevicesTable.title')), 1 /* TEXT */),
    _createVNode(_component_UiPanel, {
      class: "flex-1 overflow-y-auto",
      "no-padding": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("table", _hoisted_3, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
                                'extension',
                                'user',
                                'device',
                                'status',
                                'queueStatus',
                                'numberClient',
                                'quality',
                                'type',
                                'duration',
                            ], (header) => {
                return _createElementVNode("th", {
                  key: header,
                  class: _normalizeClass(["sticky top-0 z-10 whitespace-nowrap border-b border-gray-300 bg-gray-200 px-3 py-1.5 text-sm font-semibold text-gray-800 backdrop-blur backdrop-filter", {
                                'text-left': [
                                    'extension',
                                    'user',
                                    'numberClient',
                                    'quality',
                                ].includes(header),
                                'text-center': [
                                    'device',
                                    'status',
                                    'queueStatus',
                                    'quality',
                                    'type',
                                    'duration',
                                ].includes(header),
                            }])
                }, _toDisplayString(_ctx.$t(`report.realtime.userDevicesTable.header.${header}`)), 3 /* TEXT, CLASS */)
              }), 64 /* STABLE_FRAGMENT */))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.computedUserDevices, (item) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: item.id,
                class: "even:bg-gray-100"
              }, [
                _createElementVNode("td", _hoisted_4, _toDisplayString(item.extension), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_5, _toDisplayString(item.name), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_6, _toDisplayString(item.deviceTypeLabel), 1 /* TEXT */),
                _createElementVNode("td", {
                  class: _normalizeClass([
                                item.statusClass,
                                'whitespace-nowrap border-b border-gray-200 px-3 py-1.5 text-center text-sm font-medium',
                            ])
                }, _toDisplayString(item.statusLabel), 3 /* TEXT, CLASS */),
                _createElementVNode("td", {
                  class: _normalizeClass([
                                item.queueStatusClass,
                                'whitespace-nowrap border-b border-gray-200 px-3 py-1.5 text-center text-sm font-medium',
                            ])
                }, _toDisplayString(item.queueStatusLabel), 3 /* TEXT, CLASS */),
                _createElementVNode("td", _hoisted_7, _toDisplayString(item.phoneNumber), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_8, _toDisplayString(item.qualityLabel), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_9, _toDisplayString(item.callTypeLabel), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_10, _toDisplayString(item.duration), 1 /* TEXT */)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}